import type { HTMLAttributes } from 'react';

export const SectionGroupTitle = ({ className = '', ...rest }: HTMLAttributes<HTMLHeadingElement>) =>
  <h2 className={`mx-5 mt-8 mb-2 font-bold text-title-2 ${className}`} {...rest} />;
